import { http } from '../../core/services'

export const loadClaims = () =>
  http.get('management/claims').then(response => response.data)

export const approveClaim = id => http.patch(`management/claims/${id}/approve`)
